
import { useSingleChargingSessionAdmin } from "./useChargingSession";
import { getChargingSessionDataInflux } from "../service/chargingSessionAPI";
import { MeasurandData } from "../../stations/types/stations.types";
import { useQuery } from "react-query";

import { useGetAnalysisFilter } from "../../../common/analysis/filter/hook/core/useFilterAnalysisCore";
import { isEmptyTime } from "../../../utils/dateConverter";


export default function useChargingSessionAnalysis(
  measurand: MeasurandData,
  chargingSessionId?: string
) {
  const { chargingSessionId: chargingSessionHook, singleChargingSessionQuery } =
    useSingleChargingSessionAdmin();
  const chargingSessionFound = chargingSessionId || chargingSessionHook;
  const { filter } = useGetAnalysisFilter();

  
  const dataQuery = useQuery({
    queryKey: ["data-chargingSession", measurand, chargingSessionFound],
    queryFn: () =>
      getChargingSessionDataInflux(
        chargingSessionFound || "none",
        measurand,
        {
      
            startDate: singleChargingSessionQuery.data?.cs_start_time,
            stopDate: singleChargingSessionQuery.data?.cs_end_time && !isEmptyTime(singleChargingSessionQuery.data?.cs_end_time as any) ? singleChargingSessionQuery.data?.cs_end_time : " now() ",
        }
      ),
    enabled: !!chargingSessionFound || !!singleChargingSessionQuery.data,
  });
  return {
    dataQuery,
    filter : {...filter,
    
      startDate: singleChargingSessionQuery.data?.cs_start_time,
      stopDate: singleChargingSessionQuery.data?.cs_end_time && !isEmptyTime(singleChargingSessionQuery.data?.cs_end_time as any) ? singleChargingSessionQuery.data?.cs_end_time : " now() ",
    }
  };
}
